import React, {Component} from "react"
import PropTypes from "prop-types"

import {PartialRoute} from "@irati/utils/history/routing"
import SideNavigation from "@irati/ui/src/Navigation/SideNavigation"
import {AccountWrapper} from "@irati/ui/src/Account"

import MyPerksList from "../../components/MyPerks/MyPerksList"
import menuLinks from "../../constants/accountMenuLinks"
import mobileMenuLinks from "../../constants/accountMobileMenuLinks"

export default class AccountRoute extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired
  }

  render() {
    const {match} = this.props

    const accountProps = {
      indexRedirect: "/my-perks/new",
      MobileMenu: () => <SideNavigation links={mobileMenuLinks} />,
      mobileBack: "My perks",
      Menu: () => <SideNavigation links={menuLinks} />,
      usesNewSideNav: true
    }

    return (
      <AccountWrapper {...accountProps}>
        <PartialRoute match={match.url} path="/my-perks/new" title="My new perks" component={MyPerksList} />
        <PartialRoute
          match={match.url}
          path="/my-perks/used"
          title="My used perks"
          component={MyPerksList}
          componentProps={{isUsedPerks: true}} />
      </AccountWrapper>
    )
  }
}
